import type { RiskStatistic } from 'dashboard/hooks/useRiskStatistics';

export interface RiskChartItem extends RiskStatistic {
  colour: string;
}

/**
 * Keeps only the categories with at least one risk. Each category keeps the
 * colour of its position in the full list, so hiding empty ones does not
 * recolour the rest.
 */
export default function riskChartItems(
  risks: RiskStatistic[],
  colours: string[]
): RiskChartItem[] {
  return risks
    .map((risk, index) => ({
      ...risk,
      colour: colours[index % colours.length],
    }))
    .filter((risk) => risk.note_count > 0);
}
